import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const PageNotFound = () => {
    // const navigate = useNavigate();

    // useEffect(() => {
    //     const redirectTimeout = setTimeout(() => {
    //         navigate('/');
    //     }, 2500); 

    //     return () => clearTimeout(redirectTimeout);
    // }, [navigate]);

    return (
        <div className="flex-container">
            <div className="text-center">
                <h1>
                    <span className="fade-in" id="digit1">4</span>
                    <span className="fade-in" id="digit2">0</span>
                    <span className="fade-in" id="digit3">4</span>
                </h1>
                <h3 className="fadeIn">PAGE NOT FOUND</h3>
                <Link to="/" className="button">
                    <button type="button">Return To Home</button>
                </Link>
            </div>
        </div>
    );
};

export default PageNotFound;
